import type { ThunkAction } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import type { AnyAction } from 'redux';

import {
  initialState as initialAccountsState,
  reducer as accountsReducer,
} from 'vms/features/accounts/reducer';
import {
  initialState as initialDeletedObjectsState,
  reducer as deletedObjectsReducer,
} from 'vms/features/deletedObjects/reducer';
import {
  initialState as initialFlagsState,
  reducer as flagsReducer,
} from 'vms/features/flags/reducer';
import {
  initialState as initialInspectionState,
  reducer as inspectionReducer,
} from 'vms/features/inspection/reducer';
import {
  initialState as initialLocationsState,
  reducer as locationsReducer,
} from 'vms/features/locations/reducer';
import {
  initialState as initialNotesState,
  reducer as notesReducer,
} from 'vms/features/notes/reducer';
import {
  initialState as initialOrganizationState,
  reducer as organizationReducer,
} from 'vms/features/organizations/reducer';
import {
  initialState as initialPartsState,
  reducer as partsReducer,
} from 'vms/features/parts/reducer';
import {
  initialState as initialVendorSubletState,
  reducer as vendorSubletReducer,
} from 'vms/features/sublet/reducer';
import {
  initialState as initialVehiclesState,
  reducer as vehiclesReducer,
} from 'vms/features/vehicles/reducer';

const rootReducer = combineReducers({
  accounts: accountsReducer,
  vehicles: vehiclesReducer,
  inspection: inspectionReducer,
  flags: flagsReducer,
  parts: partsReducer,
  locations: locationsReducer,
  organization: organizationReducer,
  notes: notesReducer,
  vendorSublets: vendorSubletReducer,
  deletedObjects: deletedObjectsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export type ThunkResult<R> = ThunkAction<R, RootState, undefined, AnyAction>;

export const initialState: RootState = {
  accounts: initialAccountsState,
  vehicles: initialVehiclesState,
  inspection: initialInspectionState,
  flags: initialFlagsState,
  parts: initialPartsState,
  locations: initialLocationsState,
  organization: initialOrganizationState,
  notes: initialNotesState,
  vendorSublets: initialVendorSubletState,
  deletedObjects: initialDeletedObjectsState,
};

export default rootReducer;
